import Vue from 'vue';

// 1. 底部导航条
import {Tabbar, TabbarItem} from 'vant';

Vue.use(Tabbar).use(TabbarItem);

// 2. 加载中
import {Loading} from "vant";

Vue.use(Loading);

// 3. 图片懒加载
import {Image} from "vant";

Vue.use(Image);

// 4. 提示
import {Toast} from "vant";

Vue.use(Toast);

// 5. 蒙版弹出框
import {Dialog} from "vant";

Vue.use(Dialog);

// 6. 导航栏
import {NavBar} from "vant";

Vue.use(NavBar);

// 7. 收货地址
import {ContactCard} from "vant";

Vue.use(ContactCard);

// 8. 我的地址
import {AddressList} from "vant";

Vue.use(AddressList);

// 9. 编辑地址
import {AddressEdit} from "vant"

Vue.use(AddressEdit)

// 10. 单元格
import {Cell, CellGroup} from 'vant';

Vue.use(Cell).use(CellGroup);

// 11. 提交订单栏
import {SubmitBar} from 'vant';

Vue.use(SubmitBar);

// 12. 宫格
import {Grid, GridItem} from 'vant';

Vue.use(Grid).use(GridItem);

// 13. 弹出层
import {Popup} from "vant";

Vue.use(Popup)

// 14. 时间选择
import {DatetimePicker} from "vant";

Vue.use(DatetimePicker)

// 15. 卡片
import {Card} from 'vant';

Vue.use(Card);

// 16. 选项卡
import {Tab, Tabs} from 'vant';

Vue.use(Tab).use(Tabs);

//
import {List} from 'vant';

Vue.use(List);

//
import {Checkbox, CheckboxGroup} from 'vant';

Vue.use(Checkbox).use(CheckboxGroup);

import {Empty} from 'vant';

Vue.use(Empty);

import {Notify} from 'vant';

Vue.use(Notify);

